/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MailboxItemDirection = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type MailboxItemDirection = typeof MailboxItemDirection[keyof typeof MailboxItemDirection];


export function instanceOfMailboxItemDirection(value: any): boolean {
    for (const key in MailboxItemDirection) {
        if (Object.prototype.hasOwnProperty.call(MailboxItemDirection, key)) {
            if (MailboxItemDirection[key as keyof typeof MailboxItemDirection] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MailboxItemDirectionFromJSON(json: any): MailboxItemDirection {
    return MailboxItemDirectionFromJSONTyped(json, false);
}

export function MailboxItemDirectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxItemDirection {
    return json as MailboxItemDirection;
}

export function MailboxItemDirectionToJSON(value?: MailboxItemDirection | null): any {
    return value as any;
}

export function MailboxItemDirectionToJSONTyped(value: any, ignoreDiscriminator: boolean): MailboxItemDirection {
    return value as MailboxItemDirection;
}

